import { Box, Typography } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import useStyles from 'components/Header/components/SearchBar/SearchOption/components/SearchOptionLabel/SearchOptionLabel.styles';
import { SearchOptionLabelElement } from 'components/Header/components/SearchBar/SearchOption/types/SearchOptionLabelElement';
import { highlightFullMatch } from 'components/Header/components/SearchBar/utils/highlightMatch';

type SearchOptionLabelProps = {
  elements: SearchOptionLabelElement[];
  inputValue: string;
};

const SearchOptionLabel = ({ elements, inputValue }: SearchOptionLabelProps) => {
  const classes = useStyles();
  const nonEmptyElements = elements.filter((element) => element.value);

  return (
    <Box className={classes.root}>
      {nonEmptyElements.map((element, index) => (
        <React.Fragment key={element.label}>
          {index > 0 && <Box className={classes.divider} data-testid="divider" />}
          <Typography variant="label">
            {element.label}: {highlightFullMatch(element.value, inputValue)}
          </Typography>
        </React.Fragment>
      ))}
    </Box>
  );
};

export default SearchOptionLabel;
